import { render, staticRenderFns } from "./receipt-payment-component.vue?vue&type=template&id=a66f5812&scoped=true&"
import script from "./receipt-payment-component.vue?vue&type=script&lang=js&"
export * from "./receipt-payment-component.vue?vue&type=script&lang=js&"
import style0 from "./receipt-payment-component.vue?vue&type=style&index=0&id=a66f5812&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66f5812",
  null
  
)

export default component.exports